import { colord } from 'colord';

var ThemeColor;
(function (ThemeColor) {
    ThemeColor["PrimaryMain"] = "THEME_COLOR_primary.main";
    ThemeColor["SecondaryMain"] = "THEME_COLOR_secondary.main";
    ThemeColor["TextPrimary"] = "THEME_COLOR_text.primary";
    ThemeColor["TextSecondary"] = "THEME_COLOR_text_secondary";
    ThemeColor["TextDisabled"] = "THEME_COLOR_text_disabled";
    ThemeColor["BackgroundDefault"] = "THEME_COLOR_background_default";
    ThemeColor["BackgroundPaper"] = "THEME_COLOR_background_paper";
})(ThemeColor || (ThemeColor = {}));
var THEME_COLOR_PREFIX = "THEME_COLOR_";
var convertColor = function (theme, color) {
    if (color) {
        if (colord(color).isValid()) {
            return color;
        }
        else if (color.startsWith(THEME_COLOR_PREFIX)) {
            var themeColor = getThemeColorList(theme).find(function (themeColorElement) { return themeColorElement.value === color; });
            if (themeColor) {
                return themeColor.color;
            }
            else {
                // theme color is no longer available => return undefined
                return undefined;
            }
        }
    }
    return color;
};
var getThemeColorList = function (theme) {
    return [
        {
            label: "Primary main (".concat(theme.palette.primary.main, ")"),
            value: ThemeColor.PrimaryMain,
            color: theme.palette.primary.main
        },
        {
            label: "Secondary main (".concat(theme.palette.secondary.main, ")"),
            value: ThemeColor.SecondaryMain,
            color: theme.palette.secondary.main
        },
        {
            label: "Text primary (".concat(theme.palette.text.primary, ")"),
            value: ThemeColor.TextPrimary,
            color: theme.palette.text.primary
        },
        {
            label: "Text secondary (".concat(theme.palette.text.secondary, ")"),
            value: ThemeColor.TextSecondary,
            color: theme.palette.text.secondary
        },
        {
            label: "Text disabled (".concat(theme.palette.text.disabled, ")"),
            value: ThemeColor.TextDisabled,
            color: theme.palette.text.disabled
        },
        {
            label: "Background default (".concat(theme.palette.background["default"], ")"),
            value: ThemeColor.BackgroundDefault,
            color: theme.palette.background["default"]
        },
        {
            label: "Background paper (".concat(theme.palette.background.paper, ")"),
            value: ThemeColor.BackgroundPaper,
            color: theme.palette.background.paper
        },
    ];
};
var getAccessibleTextColor = function (theme, backgroundColor) {
    return colord(backgroundColor).luminance() < 0.5
        ? theme.palette.common.white
        : theme.palette.common.black;
};

export { THEME_COLOR_PREFIX, ThemeColor, convertColor, getAccessibleTextColor, getThemeColorList };
//# sourceMappingURL=utils.js.map
